import type { UnitInfoGrizzlyFeederInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';

export const INCLINATION_OPTIONS = [8];

export const MODELS = [
  'SW0843H',
  'SW1043H',
  'SW1052H',
  'SW1053H',
  'SW1252H',
  'SW1253H',
];

/* Returns the amount of decks for the model. If the last number equals 3 it has two decks, else one */
export const getNbrOfDecks = (modelName: string): number => {
  if (
    (modelName.slice(-1) === 'H' && modelName.slice(-2, -1) === '3') ||
    modelName.slice(-1) === '3'
  ) {
    return 2;
  }
  return 1;
};

export const getDefaultData = (): UnitInfoGrizzlyFeederInterface => {
  return {
    modelName: MODELS[0],
    moisture: 0,
    newMoisture: false,
    decks: {
      0: { separationSize: 100, display: { separationSize: true } },
      1: { separationSize: 30, display: { separationSize: true } },
    },
    inclination: INCLINATION_OPTIONS[0],
    parallelUnits: 1,
    otherModel: false,
    otherModelMaxFeedSize: 0,
    otherModelNominalCapacity: 0,
    customModelTwoDecks: false,
    nbrOfOutputs: 3,
    display: {
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
      displayUnitName: true,
      displayModelName: true,
      displayInclination: false,
      displayLoad: true,
      displaySepSizeDeck1: true,
      displaySepSizeDeck2: true,
    },
  };
};

export class GrizzlyFeederSWConfig extends BaseUnitConfig {
  static getDefaultData(): UnitInfoGrizzlyFeederInterface {
    return {
      modelName: MODELS[0],
      ...BaseUnitConfig.getBaseDefaults(),
      decks: {
        0: { separationSize: 100, display: { separationSize: true } },
        1: { separationSize: 30, display: { separationSize: true } },
      },
      inclination: INCLINATION_OPTIONS[0],
      otherModel: false,
      otherModelMaxFeedSize: 0,
      otherModelNominalCapacity: 0,
      customModelTwoDecks: false,
      nbrOfOutputs: 3,
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayInclination: false,
        displayLoad: true,
        displaySepSizeDeck1: true,
        displaySepSizeDeck2: true,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 3;
  }
}

export const grizzlyFeederSWConfig = new GrizzlyFeederSWConfig();
